<template>
  <tg-tree
    v-model="showpick"
    :keyId="options"
    :keyName="keyname"
    :options="treeOptions"
    :disabledOptions="disabledoptions"
    :search-options="treeSearchOptions"
    :parent-selectable="false" 
    :is-view="false" 
    :is-async="true"
    has-search
    :multiple = "multiple"
    @on-search="loadtreeSearch"
    @selector-click="loadTreeOptions" 
    @selected-click="getTreeSelected"
    class="emap-flow-pick-m">
  </tg-tree>
</template>
<script>
  import api from '@/api'
  import { TgTree } from "tg-tree"
  import { encode18bit }  from 'utils'
  export default {
    name: "emap-flow-pick-m",
    components: {
      [TgTree.name]: TgTree
    },
    data() {
      return {
        showpick: this.value,
        treeOptions: [],
        treeSearchOptions: []
      }
    },
    props: {
      value: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      },
      options: [String,Number,Array],
      keyname: {
        type: String,
        default: ''
      },
      disabledoptions: {
        type: Array,
        default: function() {
          return []
        }
      },
    },
    watch: {
      value: function (val) {
        if(val) this.initialize();
        this.showpick = val
      },
      showpick: function (val) {
        this.$emit('input',val)
      }
    },
    methods: {
      initialize() {
        this.loadTreeOptions()
      },
      loadtreeSearch(keyword) {
        api.getUsers({
          "appName": keyword
        }).then(data => {
          if(data) {
            let tempArr  = data.map( item => {
              item.display = item.name + "(" + encode18bit(item.id) + ")";
              return item
            })
            this.treeSearchOptions = tempArr;
          }
        });
      },
      loadTreeOptions(id) {
        api.getUsers({
          "searchKey": id || ''
        }).then(data => {
          if(data) {
            this.treeOptions = this.treeDataTranslation(data);
          }
        });
      },
      getTreeSelected(ids, label, opts) {
        this.$emit('on-confirm', ids, label, opts)
      },
      treeDataTranslation(data) {
        return data.map(obj => {
          if(obj.type === "group") {
            obj.isParent = 1;
          } else {
            obj.isParent = 0;
            obj.display = obj.name +  + "(" + encode18bit(obj.id) + ")";
          }
          obj.pId = obj.superId ? obj.superId : '';
          return obj
        });
      }
    },
    mounted () {
      // TODO
    }
  }
</script>